<template>
  <div class="picture-selector">
    <div class="dialog-head">
      <div class="dialog-head-title">选择图片</div>
      <div @click="closePictureDialog" class="dialog-head-close"></div>
    </div>
    <div class="source-layout">
      <div class="source-category">
        <el-input size="small" v-model="keyword" placeholder="请输入分组名称">
          <i class="el-icon-search el-input__icon" slot="suffix"></i>
        </el-input>
        <div class="category-list">
          <div class="category-all">
            <div class="category-all-arrow">
              <i class="el-icon-caret-bottom"></i>
            </div>
            <div class="category-all-name">全部</div>
            <div class="category-all-num">{{ detailCount[tabIndex] }}</div>
          </div>
          <div class="category-children">
            <div
              @click="selectCategory(n.id)"
              v-for="(n, i) in categorys"
              v-bind:key="i"
              class="category-item"
              :class="{ active: categoryId === n.id }"
            >
              <div class="category-item-name">{{ n.name }}</div>
              <div class="category-item-num">{{ n.source_count }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="source-divider"></div>
      <source-picture-view
        @select="pictureSelected"
        v-if="categoryId"
        :categoryId="categoryId"
        mode="selector"
      ></source-picture-view>
    </div>
    <div class="dialog-foot border">
      <span class="foot-text">已选图片 {{ selected.length }}</span>
      <el-button @click="selectCancel" type="infor" size="small">
        取消
      </el-button>
      <el-button @click="selectConfirm" type="primary" size="small">
        确认
      </el-button>
    </div>
  </div>
</template>

<script>
import { getSourceCategorys, getSourceDetail } from "@/api/course";
import SourcePictureView from "@/components/source/SourcePictureView.vue";
export default {
  components: {
    SourcePictureView,
  },
  data() {
    return {
      categoryId: "",
      keyword: "",
      categorys: [],
      tabIndex: "picture",
      detailCount: {
        picture: 0,
        audio: 0,
        video: 0,
        document: 0,
      },
      selected: [],
    };
  },
  mounted() {
    this.loadSourceDetail();
    this.loadCategorys();
  },
  methods: {
    selectCancel() {
      this.closePictureDialog();
    },
    selectConfirm() {
      this.$emit("confirm", this.selected);
    },
    pictureSelected(res) {
      this.selected = res;
    },
    closePictureDialog() {
      this.$emit("close");
    },
    async loadSourceDetail() {
      let res = await getSourceDetail();
      this.totalUsed = res.data.reduce((accumulator, current) => {
        return accumulator + current.source_size;
      }, 0);
      this.totalUsedPer =
        ((this.totalUsed / this.totalSize) * 100).toFixed(2) + "%";
      this.details = res.data.sort((a, b) => b.source_size - a.source_size);
      let pictureCount = this.details.filter(
        (item) => item.target_type === "picture"
      )[0].source_count;
      let audioCount = this.details.filter(
        (item) => item.target_type === "audio"
      )[0].source_count;
      let videoCount = this.details.filter(
        (item) => item.target_type === "video"
      )[0].source_count;
      let documentCount = this.details.filter(
        (item) => item.target_type === "document"
      )[0].source_count;
      this.detailCount = {
        picture: pictureCount,
        audio: audioCount,
        video: videoCount,
        document: documentCount,
      };
    },
    selectCategory(categoryId) {
      this.categoryId = categoryId;
    },
    async loadCategorys() {
      let res = await getSourceCategorys(this.tabIndex);
      this.categorys = res.data;
      this.selectCategory(this.categorys[0].id);
    },
  },
};
</script>

<style lang="scss">
.picture-selector {
  width: 100%;
  height: 70vh;
  border-radius: 8px;
  background-color: #ffffff;

  display: flex;
  flex-direction: column;
}

.source-layout {
  height: 0;
  width: 100%;
  flex-grow: 1;
  padding: 16px;
  box-sizing: border-box;

  display: flex;

  .source-category {
    width: 240px;
    height: 100%;

    .category-list {
      width: 100%;
      overflow: auto;
      margin-top: 8px;
      height: calc(100% - 40px);

      .category-all {
        height: 40px;
        padding: 0 8px;
        border-radius: 4px;
        box-sizing: border-box;

        display: flex;
        align-items: center;
        cursor: pointer;

        transition: all 0.2s;

        &:hover {
          background-color: #f2f7ff;
        }

        .category-all-arrow {
          width: 16px;
          height: 16px;
          display: inline-flex;
          align-items: center;
          justify-content: center;

          color: #8a9099;
        }

        .category-all-name {
          flex-grow: 1;
          margin: 0 8px;
          line-height: 40px;
          font-size: 14px;
          color: #1e2226;
        }

        .category-add-btn {
          margin-right: 8px;
          font-size: 18px;
        }

        .category-all-num {
          line-height: 40px;
          font-size: 12px;
          color: #8a9099;
        }
      }

      .category-item {
        height: 40px;
        padding: 0 8px;
        margin-top: 8px;
        border-radius: 4px;
        padding-left: 30px;
        box-sizing: border-box;

        display: flex;
        align-items: center;
        cursor: pointer;

        transition: all 0.2s;

        &.active {
          background-color: #f2f7ff;

          .category-item-name {
            color: #0366ff;
          }
        }

        &:hover {
          background-color: #f2f7ff;
        }

        .category-item-name {
          flex-grow: 1;
          margin: 0 8px;
          line-height: 40px;
          font-size: 14px;
          color: #1e2226;
          cursor: pointer;
        }

        .category-item-num {
          line-height: 40px;
          font-size: 12px;
          color: #8a9099;
        }
      }
    }
  }

  .source-divider {
    width: 1px;
    height: 100%;
    margin: 0 8px;
    background-color: #f7f8fa;
  }

  .source-block {
    width: 0;
    height: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    .source-tbl-head {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .head-text {
        white-space: nowrap;
      }

      .head-right {
        display: inline-flex;
        align-items: center;

        .head-datepicker {
          width: 240px;
        }

        .head-keyword {
          margin-left: 8px;
          width: 240px;
        }
      }
    }
    .source-tbl-info {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .info-total {
        font-size: 12px;
        color: #8a9099;
      }

      .info-right {
        display: inline-flex;
        align-items: center;
      }
    }

    .source-tbl-block {
      height: 0;
      flex-grow: 1;

      .source-grid {
        width: 100%;
        height: 100%;
        overflow: auto;

        .grid-list {
          display: flex;
          flex-wrap: wrap;

          .grid-item {
            width: 135px;
            height: 184px;
            margin-top: 16px;
            margin-right: 16px;

            .grid-item-cover {
              width: 135px;
              height: 135px;
              position: relative;

              &:hover {
                .cover-mask {
                  opacity: 1;
                }
              }

              .cover-img {
                width: 100%;
                height: 100%;
                border-radius: 4px;
                background-color: #f7f8fa;
              }

              .cover-mask {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 4px;
                background-color: rgba($color: #000000, $alpha: 0.7);
                transition: all 0.2s;
                opacity: 0;

                display: flex;
                align-items: center;
                justify-content: center;

                .mask-btn {
                  font-weight: 500;
                  font-size: 12px;
                  color: #ffffff;
                  cursor: pointer;
                }

                .mask-divider {
                  width: 1px;
                  height: 10px;
                  margin: 0 8px;
                  background-color: rgba($color: #ffffff, $alpha: 0.3);
                }
              }
            }

            .grid-item-info {
              padding-top: 8px;

              .grid-item-title {
                height: 20px;
                display: flex;
                align-items: center;

                .title-text {
                  width: 110px;
                  height: 20px;
                  line-height: 20px;
                  font-size: 14px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }

              .grid-item-detail {
                display: flex;
                align-items: center;
                justify-content: space-between;

                margin-top: 4px;
                line-height: 16px;
                font-size: 12px;
                color: #8a9099;
              }
            }
          }
        }
      }
    }

    .source-tbl-bottom {
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .bottom-btns {
        display: inline-flex;
        align-items: center;

        .bottom-text {
          margin-right: 10px;
        }
      }
    }
  }
}

.source-status {
  display: inline-flex;
  align-items: center;
  font-size: 14px;

  &::before {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 6px;
    background-color: #2fce63;
  }
}

.info-condition {
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  color: #1e2226;
  cursor: pointer;
}

.source-item {
  width: 320px;
  display: flex;
  align-items: center;

  .source-item-cover {
    width: 80px;
    height: 60px;
    position: relative;

    .cover-img {
      width: 80px;
      height: 60px;
      border-radius: 4px;
      background-color: #f7f8fa;
    }

    .cover-play {
      width: 24px;
      height: 24px;
      cursor: pointer;

      position: absolute;
      top: 50%;
      left: 50%;
      border-radius: 50%;
      background-size: 100%;
      transform: translate(-50%, -50%);
      background-color: rgba($color: #000000, $alpha: 0.4);
      background-image: url(https://image.renrenjiang.cn/teacher_center/douyin/icon_source_video_play_ico.png);

      &:hover {
        background-color: rgba($color: #000000, $alpha: 0.9);
      }
    }
  }

  .source-item-info {
    width: 0;
    flex-grow: 1;
    margin-left: 10px;

    .source-item-name {
      width: 100%;
      max-height: 40px;
      line-height: 20px;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .source-item-dur {
      font-size: 12px;
      color: #8a9099;
    }
  }
}

.grid-checkbox {
  display: inline-flex;
  align-items: center;

  .el-checkbox__input {
    transform: translateY(1px);
  }
}
</style>
<style lang="scss">
.el-dropdown-menu {
  border: none;

  .popper__arrow {
    border-bottom-color: rgba($color: #d6d6d6, $alpha: 0.4) !important;
  }
}
</style>
